<template>
<div class="container">
    <div class="message-wrap">
        <div class="message">
            <div>
                <div class="head">{{$t('global.企业名称')}}</div>
                <div class="content">GeeksArt</div>
            </div>
        </div>
        <div class="message resetP">
            <div>
                <div class="head">{{$t('global.创作领域')}}</div>
                <div class="content">{{$t('global.艺术')}}+{{$t('global.科技')}}
                    Art + Technology

                    {{$t('global.致力于公共艺术互动装置的设计与新媒体艺术的应用')}}
                    Focusing on the design of Public Interactive Installations and application of New Media Art
                </div>
            </div>
        </div>
        <div class="message resetP">
            <div>
                <div class="head">{{$t('global.账户链接')}}</div>
                <div class="content"><img src="/static/peopleCenter/social.png" :alt="$t('global.社交')"></div>
            </div>
        </div>
        <div class="message resetP">
            <div>
                <div class="head">{{$t('global.个人介绍')}}</div>
                <div class="content">{{$t('global.千核科技')}} －{{$t('global.广州')}}／{{$t('global.上海')}}／{{$t('global.武汉')}} <br><br><br>

                    {{$t('global.广州')}}<br>
                    T: 020-38342513<br>
                    E:2853739621@qq.com<br>


                    {{$t('global.上海')}}<br><br><br>
                    T:13122658716<br>
                    E: gamarketing@qq.com<br><br><br>


                    W： www.geeks-art.com<br>
                    {{$t('global.微信公众号')}} ：geeksart{{$t('global.等')}}。</div>
            </div>
        </div>
    </div>

</div>
</template>

<script type="text/ecmascript-6">
    export default {
        name:'CORBriefIntroduction'
    }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.message
    display flex
    padding-top 0.5rem
    >div
        flex 1
        .head
            font-size 0.2rem
            color #000000
        .content
            font-size 0.16rem
            color #777777
            margin-top 0.2rem
            img
                width 2.05rem

.message-wrap
    background-color #ffffff
    margin 0.2rem 0 0.6rem 0
    padding 0 0.5rem 0.5rem
.resetP
    padding-top 0.75rem
</style>


// WEBPACK FOOTER //
// src/components/CORBriefIntroduction.vue